<template>
    <router-view></router-view>
</template>

<script>
 
export default {
  name: 'app',
  data () {
    return {}
  },
  created() {
    
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue